import { z } from 'zod';

import { ColumnsContainerPropsSchema as BaseColumnsContainerPropsSchema } from '@usewaypoint/block-columns-container';

const columnSchema = z.object({ childrenIds: z.array(z.string()) });
const columnsTupleSchema = z.tuple([
  columnSchema,
  columnSchema,
  columnSchema,
  columnSchema,
]);
const fixedWidthsTupleSchema = z.tuple([
  z.number().nullish(),
  z.number().nullish(),
  z.number().nullish(),
  z.number().nullish(),
]);

function normalizeColumns(value: unknown) {
  const columns = Array.isArray(value) ? value : [];
  return [
    columns[0] ?? { childrenIds: [] },
    columns[1] ?? { childrenIds: [] },
    columns[2] ?? { childrenIds: [] },
    columns[3] ?? { childrenIds: [] },
  ];
}

function normalizeFixedWidths(value: unknown) {
  if (!Array.isArray(value)) {
    return value;
  }
  return [value[0], value[1], value[2], value[3]];
}

const ColumnsContainerPropsSchema = z.object({
  style: BaseColumnsContainerPropsSchema.shape.style,
  props: z
    .object({
      columns: z.preprocess(normalizeColumns, columnsTupleSchema),
      fixedWidths: z
        .preprocess(normalizeFixedWidths, fixedWidthsTupleSchema)
        .optional()
        .nullable(),
      columnsCount: z.union([z.literal(2), z.literal(3), z.literal(4)]).optional().nullable(),
      columnsGap: z.number().optional().nullable(),
      contentAlignment: z.enum(['top', 'middle', 'bottom']).optional().nullable(),
    })
    .optional()
    .nullable(),
});

export type ColumnsContainerProps = z.infer<typeof ColumnsContainerPropsSchema>;
export default ColumnsContainerPropsSchema;
